var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnestesiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68583 15.8223C8.88109 16.0176 8.88109 16.3341 8.68583 16.5294L5.78202 19.4332C5.58676 19.6285 5.27018 19.6285 5.07491 19.4332C4.87965 19.238 4.87965 18.9214 5.07491 18.7261L7.97872 15.8223C8.17398 15.627 8.49057 15.627 8.68583 15.8223Z",
    fill: "#358888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4397 4.1941C18.372 3.70377 18.9663 3.4084 19.3163 3.75839L20.7475 5.1896C21.0975 5.53961 20.8021 6.13391 20.3118 6.0662C20.1862 6.04885 20.0697 5.99095 19.98 5.90129L19.6459 5.56714L18.5852 6.6278L20.7065 8.74912C20.9018 8.94438 20.9018 9.26096 20.7065 9.45623C20.5113 9.65149 20.1947 9.65149 19.9994 9.45623L19.6459 9.10267L12.5748 16.1737C12.113 16.6356 11.425 16.7333 10.8674 16.4669L10.807 16.5273C10.026 17.3083 8.75966 17.3083 7.97861 16.5273C7.19756 15.7462 7.19756 14.4799 7.97861 13.6989L8.03896 13.6385C7.77261 13.0809 7.87034 12.3929 8.33216 11.9311L15.4032 4.86003L15.0497 4.50648C14.8544 4.31122 14.8544 3.99463 15.0497 3.79937C15.2449 3.60411 15.5615 3.60411 15.7568 3.79937L16.4638 4.5064L17.8781 5.92069L18.9388 4.86004L18.6046 4.52589C18.5149 4.43623 18.457 4.31972 18.4397 4.1941ZM16.1103 5.56714L13.2819 8.39557L16.1103 11.224L18.9388 8.39557L16.1103 5.56714ZM8.68572 14.406C8.29519 14.7965 8.29519 15.4297 8.68572 15.8202C9.07624 16.2107 9.7094 16.2107 10.0999 15.8202L8.68572 14.406Z",
    fill: "#358888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnestesiIcon);
export default __webpack_public_path__ + "static/media/anestesi_icon.b98ce9b391a2e4cfda76c3e1bcbc03c5.svg";
export { ForwardRef as ReactComponent };